// components/Composite/ToolsShowcase/ToolsShowcase.js
import React from 'react';
import PropTypes from 'prop-types';
import HorizontalScroll from '../../Molecules/HorizontalScroll/HorizontalScroll';
import { ScrollableCard } from '../../Molecules';

const ToolsShowcase = ({ value }) => {
  if (!value) {
    console.warn('⚠️ No value provided for ToolsShowcase component');
    return null;
  }

  const { heading, sub_heading, intro, tools } = value;

  if (!tools || !Array.isArray(tools) || tools.length === 0) {
    console.warn('⚠️ No tools provided in ToolsShowcase');
    return null;
  }

  return (
    <section className="section section-full">
      <div className="section__inner">
        <div className="viewport-90 viewport-90--auto">
          
          {/* Header content */}
          {(heading || sub_heading || intro) && (
            <div className="content-element content-element-tight">
              <div className="stack stack-tight">
                {heading && <div className="text-section-title">{heading}</div>}
                {sub_heading && <div className="text-section-support">{sub_heading}</div>}
                {intro && <div className="text-body">{intro}</div>}
              </div>
            </div>
          )}
          {/* Horizontal scroll area */}
          <HorizontalScroll 
            items={tools}
            itemWidth={320}
            gap="normal"
            showArrows={true}
          >
            {(tool) => (
              <ScrollableCard 
                title={tool.title}
                subtitle={tool.subtitle}
                image={tool.image}
                href={tool.link}
              />
            )}
          </HorizontalScroll>
          
        </div>
      </div>
    </section>
  );
};

ToolsShowcase.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    sub_heading: PropTypes.string,
    intro: PropTypes.string,
    tools: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        image: PropTypes.object,
        link: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default ToolsShowcase;